import script from "./HeaderHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderHeader.vue?vue&type=script&setup=true&lang=js"

import "./HeaderHeader.vue?vue&type=style&index=0&id=638d8022&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638d8022"]])

export default __exports__